/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserSelector
 */
export interface UserSelector {
    /**
     * 
     * @type {Array<string>}
     * @memberof UserSelector
     */
    teams?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserSelector
     */
    users?: Array<string>;
}

export function UserSelectorFromJSON(json: any): UserSelector {
    return UserSelectorFromJSONTyped(json, false);
}

export function UserSelectorFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserSelector {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'teams': !exists(json, 'teams') ? undefined : json['teams'],
        'users': !exists(json, 'users') ? undefined : json['users'],
    };
}

export function UserSelectorToJSON(value?: UserSelector | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'teams': value.teams,
        'users': value.users,
    };
}

